'use client';

import { useState } from 'react';
import Modal from '@/app/Components/Modal';
import { BranchIcon } from '@/app/Components/AcademicIcons';
import ScheduleChangeProposalPanel, { type ScheduleChangeProposalPanelProps } from './ScheduleChangeProposalPanel';

export default function ScheduleHistoryControl(props: ScheduleChangeProposalPanelProps) {
  const [open, setOpen] = useState(false);
  return <>
    <button type="button" onClick={() => setOpen(true)} aria-label={props.proposal ? 'Open schedule history, pending changes' : 'Open schedule history'} aria-haspopup="dialog" aria-expanded={open} title="Schedule history" className="relative ml-auto inline-flex min-h-12 min-w-12 items-center justify-center rounded-control border border-line bg-surface text-content hover:bg-surface-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus md:min-h-9 md:min-w-9">
      <BranchIcon className="h-4 w-4" />
      {props.proposal ? <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-[var(--ss-ai)]" aria-hidden="true" /> : null}
    </button>
    <Modal isOpen={open} onClose={() => setOpen(false)} title="Schedule history" size="full">
      {!props.loading && !props.proposal && !props.revisions.length ? <p className="text-sm text-content-muted">No saved history yet.</p> : <ScheduleChangeProposalPanel {...props} embedded />}
    </Modal>
  </>;
}
